
export default {
    namespaced: true,
    store: {}
}


// WEBPACK FOOTER //
// ./src/store/modules/janus.js